export default __webpack_public_path__ + "static/media/iso9001.828a191d.jpeg";